export default [
  {
    label: '消耗',
    prop: 'cost_total',
    width: '130px',
  },
  // {
  //   label: '请求数',
  //   prop: 'request',
  //   width: '120px',
  // },
  // {
  //   label: '有效请求数',
  //   prop: 'served_request',
  //   width: '120px',
  // },
  // {
  //   label: '填充率',
  //   prop: 'filled_rate',
  // },
  {
    label: '展示数',
    prop: 'impression_total',
    width: '120px',
  },
  {
    label: '点击数',
    prop: 'click_total',
    width: '110px',
  },
  {
    label: 'CTR',
    prop: 'ctr',
  },
  {
    label: 'ECPM',
    prop: 'ecpm',
  },
  {
    label: 'ACP',
    prop: 'acp',
  },
  {
    label: '有消耗账户数',
    prop: 'served_account_num',
    width: '120px',
  },
];
